module.exports = __webpack_public_path__ + "static/media/cash-deposits.57ec0884.svg";